// Batch Size
export const FIND_SCHEDULES_ON_DATE_SIZE = 100;
export const DELIVERIES_ON_DATE_SIZE = 700;

// URL
export const BASE_URL = process.env.REACT_APP_BASE_URL!;
export const WEB_SOCKET_URL = process.env.REACT_APP_WEB_SOCKET_URL!;

// export const BASE_URL2 = "http://localhost:8000/api";
export const BASE_URL2 = process.env.REACT_APP_BASE_URL!;

// Time
export const STOMP_TIME_OUT_MILLISECOND = 2000;
export const UPDATE_COORDINATES_LOCATION_INTERVAL = 5000;
export const SOCKET_CONNECT_TIMEOUT = 1000;
export const DEBOUNCE_DELAY = 300;

// Version - injected at build time via REACT_APP_VERSION from package.json's
// npm_package_config_(prod|qa)version, so the header label always matches
// the image tag without manual sync.
export const VERSION_NUMBER = process.env.REACT_APP_VERSION || "dev";

// Auth
export const BEARER = "Bearer ";
export const PHONE_PLACEHOLDER = "아이디";
export const PASSWORD_PLACEHOLDER = "비밀번호";
